module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_2.c66be2ca.png";